import { render, staticRenderFns } from "./tab-account.vue?vue&type=template&id=7dfd19be&scoped=true&"
import script from "./tab-account.vue?vue&type=script&lang=js&"
export * from "./tab-account.vue?vue&type=script&lang=js&"
import style0 from "./tab-account.vue?vue&type=style&index=0&id=7dfd19be&prod&scoped=true&lang=less&"
import style1 from "./tab-account.vue?vue&type=style&index=1&id=7dfd19be&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfd19be",
  null
  
)

export default component.exports